/* eslint-disable no-console */
'use client'
import { captureException } from '@sentry/nextjs'
import { Component, ReactNode } from 'react'

interface IErrorBoundaryProps {
  readonly fallback: ReactNode | ((error: any) => ReactNode)
  readonly children: ReactNode
}

interface IErrorBoundaryState {
  hasError: boolean
  error: any
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props)

    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error }
  }

  componentDidCatch(error: any, info: any) {
    console.info(`Error: ${error}`)
    console.info(`Component Stack: ${info?.componentStack}`)

    captureException(`Error: ${error}`, info?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      const { fallback } = this.props

      return typeof fallback === 'function' ? fallback(this.state.error) : fallback
    }

    return this.props.children
  }
}

export default ErrorBoundary
